import React, { Component } from "react";
import { BsyUtils } from "../../utils/Utils";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyDialog from '../BsyDialog';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import './index.css';
import BsyAlert from "../BsyAlert";

export default class BsyCreateRelationPane extends Component {
    static defaultProps =  {
        relation_list: [],
        relationMap: {},
        jobtitles: [],
    }
    constructor(props) {
        super(props);
        this.state = {
            relation_list: props.relation_list,
            relationMap: props.relationMap,
            jobtitles: props.jobtitles,
            createText: props.createText || React.language('add.relation'),
            listName: props.listName || React.language('relation.name'),
            editedList: {},
            deledItems: [],
        }
        this.tableCont = React.createRef();
        this.batchText = React.createRef();
        this.onDragEnd = this.onDragEnd.bind(this);
    }

    onDragEnd(result) {
        this.tableCont.current.classList.remove('drag')
        if (!result.destination) {
            return;
        }
        this.onNodeSort(result);
    }

    onDragStart = (result) => {
        this.tableCont.current.classList.add('drag')
    }

    onNodeSort = (result) => {
        this.groupNodeMove(result);
    }

    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        // const first = result.splice(0, 1);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    groupNodeMove = (attr) =>{
        const customGroup = [...this.state.relation_list];
        const groupList = this.reorder(
            customGroup,
            attr.source.index,
            attr.destination.index
        );
        const outsiders = [...groupList];
        // this.props.outsiders = groupList;
        
        this.setState({
            relation_list: outsiders
        },()=>{
            if (this.props.nodeSort) {
                this.props.nodeSort(outsiders)
            }
        });
    }

    operationEditOpen = (item) =>{
        return (event)=>{
            const { relation_list } = this.state;
            const t = event.currentTarget;
            if(this.hasDuplicateName()){
                return;
            }
            relation_list.map((res, index) => {
                if(res._id === item._id){
                    relation_list[index].isEdit = true;
                }
            })
            this.setState({relation_list}, ()=>{
                t.parentElement.parentElement.parentElement.children[0].children[0].focus();
            })
        }
    }
    isDuplicate = false;
    isEmptyName = false;
    isMaxName = false;
    errorId = '';
    operationEditClose = (item) =>{
        return (event)=>{
            const { relation_list, editedList, relationMap } = this.state;
            let i = "";
            let name = this.extractText(event.currentTarget.value).trim();
            event.currentTarget.value = name;
            this.isDuplicate = false;
            this.isEmptyName = false;
            this.isMaxName = false;
            relation_list.map((res, index) => {
                if(res._id === item._id){
                    i = index;
                }
                if(res.name === name && res._id !== item._id){
                    this.isDuplicate = true;
                    this.errorId = item._id;
                }
            })
            if(name === ''){
                this.isEmptyName = false;
                // this.errorId = item._id;
                // tipAlert({
                //     msg: this.props.isJobTitle ? React.language('position.empty.name') : React.language('relation.empty.name'),
                //     type: 'warning',
                // })
                // event.currentTarget.focus();
                // return;
            }else{
                if(this.isDuplicate){
                    tipAlert({
                        msg: this.props.isJobTitle ? React.language('position.duplicate.name') : React.language('relation.duplicate.name'),
                        type: 'warning',
                    })
                    event.currentTarget.focus();
                    return;
                }else{
                    if(this.props.isJobTitle && name.length > 16){
                        this.isMaxName = true;
                        this.errorId = item._id;
                        tipAlert({
                            msg: React.language('position.length.max.name'),
                            type: 'warning',
                        })
                        event.currentTarget.focus();
                        return;
                    }
                    if(!item.isNew){
                        editedList[relationMap[relation_list[i]._id]] = [
                            relationMap[relation_list[i]._id].name, name
                        ];
                    }
                    relation_list[i].name = name;
                    relation_list[i].isEdit = false;
                }
            }

            this.setState({relation_list, editedList})
        }
    }

    extractText = (inputString) => {
        const regex = /[\u4e00-\u9fa5a-zA-Z0-9]+/g;
        const matches = inputString.match(regex);
        
        if (matches) {
            return matches.join('');
        } else {
            return '';
        }
    }
    
    operationDelOpen = (item) =>{
        return ()=>{
            const { relation_list, deledItems } = this.state;
            relation_list.map((res, index) => {
                if(res._id === item._id){
                    if(item.exist){
                        BsyAlert({
                            title: React.language("position.del.tip.title"),
                            msg: React.language("position.del.tip.msg"),
                            type: "warning",
                            text4Ok: React.language("delete"),
                            text4Cancel: React.language("cancel"),
                            OkType: "red",
                            ok:  () => {
                                if(this.errorId ===item._id){
                                    this.isDuplicate = false;
                                    this.isEmptyName = false;
                                    this.isMaxName = false;
                                    this.errorId = '';
                                }
                                deledItems.push(item);
                                relation_list.splice(index, 1);
                                this.setState({relation_list, deledItems});
                            }
                        })
                    }else{
                        if(this.errorId ===item._id){
                            this.isDuplicate = false;
                            this.isEmptyName = false;
                            this.isMaxName = false;
                            this.errorId = '';
                        }
                        deledItems.push(item);
                        relation_list.splice(index, 1)
                        this.setState({relation_list, deledItems});
                    }
                }
            })


        }
    }


    createRelation = () =>{
        const { relation_list } = this.state;
        const _id = BsyUtils._genFormEventId();
        relation_list.push({
            _id,
            create_type: '0',
            name: '',
            sort: relation_list.length + 1,
            isEdit: true,
            isNew: true
        })
        this.setState({relation_list}, ()=>{
            this.tableCont.current.children[0].children[relation_list.length-1].children[0].children[0].focus();
        })
    }

    isDuplicateName = (item) =>{
        const { relation_list } = this.state;
        let isDuplicate = false;
        relation_list.map((res, index) => {
            if(res._id !== item._id && res.name === item.name){
                isDuplicate = true;
            }
        })
        return isDuplicate;
    }

    hasDuplicateName = () =>{
        const { relation_list } = this.state;
        let isDuplicate = false;
        relation_list.map((res, index) => {
            if(this.isDuplicateName(res)){
                isDuplicate = true;
            }
        })
        return isDuplicate;
    }

    verifyName = () =>{
        const { relation_list } = this.state;
        let isDuplicate = false;
        let isEmpty = false;
        relation_list.map((res, index) => {
            // if(res.name === ''){
            //     isEmpty = true;
            // }
            if(this.isDuplicateName(res)){
                isDuplicate = true;
            }
        })
        return [isDuplicate, isEmpty];
    }

    hasEmptyName = () =>{
        const { relation_list } = this.state;
        let isEmpty = false;
        relation_list.map((res, index) => {
            if(res.name === ''){
                isEmpty = true;
            }
        })
        return isEmpty;
    }
    
    onSave = () =>{
        let verify = this.verifyName();
        if(verify[1]){
            return;
        }
        if(verify[0]){
            return;
        }
        if(this.isDuplicate){
            return;
        }
        if(this.isEmptyName){
            return;
        }
        if(this.isMaxName){
            return;
        }
        let relationMap = {};
        let list = [];
        this.state.relation_list && this.state.relation_list.map((res =>{
          relationMap[res._id] = res;
          if(res.name !== ''){
              list.push(res)
          }
        }));
        this.props.onSave && this.props.onSave(list, relationMap, this.state.editedList, this.state.deledItems);
        this.props.dialogRef && this.props.dialogRef.closeAlter();
    }

    cancel = () =>{
        this.props.dialogRef && this.props.dialogRef.closeAlter();
    }

    batchAddJobtitle = () =>{
        const { relation_list } = this.state;
        let adds = [];
        let repeats = [];
        let maxLength =[];
        const jobtitles = relation_list.map(res=>{
            return res.name
        })
        BsyDialog({
            title: React.language("position.add.batch"),
            height: 470,
            width: 450,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
                setTimeout(()=>{
                    this.batchText.current && this.batchText.current.focus();
                }, 30)
                return <div className="add-jobtitle-name">
                    <div className="add-jobtitle-tip">*{React.language("address.book.dept.jobtitle.addnew.tip")}</div>
                    <textarea
                      ref={this.batchText}
                      style={{ height: 290, lineHeight: "20px", marginTop: 12 }}
                      onKeyUp={e => {
                          adds = [];
                          repeats = [];
                          maxLength =[]
                          let val = e.target.value;
                          let ds = val.split('\n');
                          for (let index = 0; index < ds.length; index++) {
                              let element = this.extractText(ds[index].trim()) + "";
                              if (element) {
                                  element += "";

                                  if (jobtitles.indexOf(element) === -1) {
                                      if(element.length > 16){
                                          maxLength.push(element)
                                      }else {
                                          adds.push(element.trim())
                                      }
                                  } else {
                                      repeats.push(element)
                                  }
                              }
                          }
                      }}
                    >

                    </textarea>
                </div>
            },
            onOk: () => {
                if(maxLength.length){
                    tipAlert({
                        type: 'warning',
                        msg: React.language('position.add.tip1',{name: maxLength.join('、'), max: 16})
                    })
                    return false
                }
                if (repeats.length) {
                    tipAlert({
                        type: 'warning',
                        msg: React.language('position.add.tip2',{name: repeats.join('、')})
                    })
                    return false
                }
                const new_relation_list = relation_list.concat(adds.map(res=>{
                    const id = BsyUtils._genFormEventId();
                    return {
                        name: res,
                        _id: id,
                        isNew: true
                    }
                }))

                this.setState({
                    relation_list: [...new_relation_list]
                })
            }
        })
    }

    render() {
        const { relation_list, createText, listName } = this.state;
        return <div className='create-relation-pane' >
            <div className="createRelationBtn" onClick={this.createRelation}>
                <i className="icon-add"></i>
                <span>{createText}</span>
            </div>
            <div className="relation-list">
                <div className="relation-table">
                    <div className="list-header">
                        <div className="header-tr">
                            <div className="header-td">{listName}</div>
                            <div className="header-td">{React.language('order.operation')}</div>
                        </div>
                    </div>
                    <div className={`list-body ${relation_list.length >= 8 ? "hasMore" : ""}`} ref={this.tableCont}>
                        {
                            <DragDropContext onDragStart={this.onDragStart} onDragEnd={this.onDragEnd}>
                                <Droppable droppableId="droppable">
                                    {(provided, snapshot) => (
                                      <div
                                        {...provided.droppableProps}
                                        // 为了使 droppable 能够正常工作必须 绑定到最高可能的DOM节点中provided.innerRef.
                                        ref={provided.innerRef}
                                      >
                                          {
                                            relation_list && relation_list.map((item, index) => (
                                              <Draggable shouldRespectForcePress={true} key={item._id} draggableId={item._id} index={index}>
                                                  {
                                                      (provided, snapshot) => (
                                                        <div className="body-tr"
                                                             ref={provided.innerRef}
                                                             {...provided.draggableProps}
                                                        >
                                                            <div className={`body-td ${item.isEdit ? "edit" : ""}`}>
                                                                <input placeholder={this.props.isJobTitle ? React.language('position.placeholder.name') : React.language('relation.placeholder.name')} maxLength={64} type="text" onBlur={this.operationEditClose(item)} readOnly={!item.isEdit} defaultValue={item.name}/>
                                                            </div>
                                                            <div className="body-td">
                                                                <div className={`operation ${item.create_type === "1" ? "noOperate" : ""}`}>
                                                                    <span className="operationBtn edit" onClick={item.create_type === "1" ? ()=>{} : this.operationEditOpen(item)}>{React.language("edit")}</span>
                                                                    <i className="operationBtn del icon-remove-bold" onClick={item.create_type === "1" ? ()=>{} : this.operationDelOpen(item)}></i>
                                                                    <i className="operationBtn move icon-drag-bold" {...provided.dragHandleProps}></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                      )
                                                  }
                                              </Draggable>
                                            ))
                                          }
                                          {
                                              provided.placeholder
                                          }
                                      </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        }
                    </div>
                </div>
            </div>
            <div className="relation-footer">
                <div className="footer-left-btn">
                    {
                        this.props.isJobTitle && <div className="batchAddBtn" onClick={this.batchAddJobtitle}>
                          <i className="icon-add"></i>
                          <span>{React.language("batchAdd")}</span>
                      </div>
                    }
                </div>
                <div className="footer-btn">
                    <div className="footerBtn cancel" onClick={this.cancel}>{React.language('cancel')}</div>
                    <div className="footerBtn save" onClick={this.onSave}>{React.language('save')}</div>
                </div>
            </div>
        </div>
    }
}